module.exports = __webpack_public_path__ + "img/preview-4.abd1137a.png";